import { Modifier } from './Modifier';
export class LayerModifier extends Modifier {
    constructor(disabled, parameters, noise3D) {
        super('layer', disabled, parameters, true);
        this.noise3D = noise3D;
    }
    apply(geometry) {
        if (this.disabled)
            return;
        const positions = geometry.attributes.position.array;
        const { amplitude = 8, bunchiness = 0.3, layer_count = 8, seed = 42, max_angle = 35 } = this.parameters;
        const noise_scale = 0.5; // Fixed value for gentle organic effect
        // Ensure layer_count doesn't exceed 15
        const effective_layer_count = Math.min(layer_count, 15);
        // Find the height range of the geometry
        let minY = Infinity;
        let maxY = -Infinity;
        for (let i = 0; i < positions.length; i += 3) {
            const y = positions[i + 1];
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        const total_height = maxY - minY;
        for (let i = 0; i < positions.length; i += 3) {
            const x = positions[i];
            const y = positions[i + 1];
            const z = positions[i + 2];
            const radius = Math.sqrt(x * x + z * z);
            // Normalize y to 0-1 range
            const normalized_y = (y - minY) / total_height;
            // Create exactly layer_count number of shapes
            const layer_height = 1.0 / effective_layer_count;
            const current_layer = Math.floor(normalized_y / layer_height);
            // Calculate progress within the current layer
            const layer_progress = (normalized_y % layer_height) / layer_height;
            // Add organic variation that's unique to each layer
            const organic = this.noise3D(x * noise_scale + seed, (current_layer * 100 + normalized_y) * noise_scale + seed, z * noise_scale + seed);
            let fold;
            // Normal wave pattern for the rest
            const wave = (Math.sin(layer_progress * Math.PI * 2) * 0.5 + 0.5);
            const vertical_profile = wave;
            fold = amplitude * (vertical_profile * (1 - bunchiness) + organic * bunchiness);
            // Displace radially outward, creating distinct shapes for each layer
            const nx = x / (radius + 1e-6);
            const nz = z / (radius + 1e-6);
            // Apply displacement
            positions[i] += nx * fold;
            positions[i + 2] += nz * fold;
            //positions[i + 1] += fold * 0.1;
            // Scale the height based on the base height
            const baseHeight = this.parameters.base_height || 1.0;
            positions[i + 1] *= baseHeight;
        }
        geometry.attributes.position.needsUpdate = true;
        geometry.computeVertexNormals();
    }
}
